export const folderKeys = {
  all: ['folders'] as const,
  lists: () => [...folderKeys.all, 'list'] as const,
  listWithItems: () => [...folderKeys.lists(), 'items'] as const,
  listSearch: () => [...folderKeys.lists(), 'search'] as const,
  details: () => [...folderKeys.all, 'detail'] as const,
  playNext: () => [...folderKeys.all, 'play-next'] as const,
  detail: (id: string) => [...folderKeys.details(), { id }] as const,
  /** 폴더를 바꾸는 뮤테이션 공통 키. `useIsMutating` 으로 저장 중 여부를 셀 때 쓴다. */
  mutations: () => [...folderKeys.all, 'mutation'] as const,
} as const;
